package presentation.screens.business.inventory.category.list

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.productCategory.viewModel.ProductCategoryViewModel
import presentation.screens.business.inventory.category.component.ProductCategoryRow
import presentation.screens.business.inventory.category.create.CreateCategoryScreen
import presentation.screens.business.inventory.category.edit.EditCategoryScreen
import theme.ThemeColor

class CategoryListScreen : Screen {
    val viewModel = ProductCategoryViewModel()

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val allCategories = viewModel.allCategory.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.fetchAllProductCategory()
        }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = "Category", onBackPress = {
                navigator?.pop()
            }, onClickAdd = {
                navigator?.push(CreateCategoryScreen())
            })
            AppLoader(viewModel)
            if (allCategories.value.isNotEmpty()) {
                LazyColumn {
                    items(count = allCategories.value.count()) { index ->
                        ProductCategoryRow(category = allCategories.value[index], onClick = {
                            viewModel.setEditCategory(it)
                            navigator?.push(EditCategoryScreen())
                        })
                    }
                }
            } else {
                EmptyData(viewModel = viewModel) {
                    viewModel.fetchAllProductCategory()
                }
            }
        }
    }
}